import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../app/axiosInterceptor';
import moment from 'moment';
export const reportFuelDrainFill = createAsyncThunk(
  'report/reportFuelDrainFill',
  (
    {
      licensePlates = [],
      licensePlate = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    let licensePlateParams = '';
    if (Array.isArray(licensePlates) && licensePlates.length > 0) {
      licensePlateParams = licensePlates
        .map(plate => `licensePlate=${encodeURIComponent(plate)}`)
        .join('&');
    } else if (licensePlate) {
      licensePlateParams = `licensePlate=${encodeURIComponent(licensePlate)}`;
    }
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/filldrain/data?${licensePlateParams}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

// Báo cáo tổng hợp hoạt động
export const reportActivitySummary = createAsyncThunk(
  'report/reportActivitySummary',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/active-overview/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

// Báo cáo chi tiết hoạt động
export const reportActivityDetail = createAsyncThunk(
  'report/reportActivityDetail',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/active-detail/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

// Báo cáo tổng hợp nhiên liệu
export const reportFuelSummary = createAsyncThunk(
  'report/reportFuelSummary',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/summary/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

// Báo cáo tiêu hao nhiên liệu
export const reportFuelConsumption = createAsyncThunk(
  'report/reportFuelConsumption',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/consumption/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const reportMonitoringArea = createAsyncThunk(
  'report/reportMonitoringArea',
  (
    {
      licensePlates = [],
      licensePlate = '',
      groupID = '',
      firstTime = '',
      lastTime = '',
      pageSize = 30,
      agencyId = '',
      page = ''
    },
    { rejectWithValue }
  ) => {
    // Ưu tiên licensePlates array, fallback về licensePlate string
    const licensePlateValue = Array.isArray(licensePlates) && licensePlates.length > 0
      ? licensePlates
      : (licensePlate || []);

    const params = {
      licensePlate: licensePlateValue,
      groupID: groupID,
      firstTime: firstTime,
      lastTime: lastTime,
      page: page,
      pageSize: pageSize
    };

    const queryString = buildQueryString(params);
    const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/zone/data?${queryString}`;

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

// Helper function: Build query string from params
const buildQueryString = (params) => {
  const queryParams = [];

  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          // Tạo nhiều param cùng tên cho mỗi item trong array
          value.forEach(item => {
            if (item !== undefined && item !== null && item !== '') {
              queryParams.push(`${key}=${item}`);
            }
          });
        }
      } else {
        queryParams.push(`${key}=${value}`);
      }
    }
  });

  return queryParams.join('&');
};

// Helper function: Download blob as file
const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Export báo cáo tổng hợp nhiên liệu ra Excel
export const exportFuelSummaryExcel = createAsyncThunk(
  'report/exportFuelSummaryExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/summary/excel?${queryString}`;
      const fileName = `Bao_cao_tong_hop_nhien_lieu_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

// Export báo cáo tiêu hao nhiên liệu ra Excel
export const exportFuelConsumptionExcel = createAsyncThunk(
  'report/exportFuelConsumptionExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/oil/consumption/excel?${queryString}`;
      const fileName = `Bao_cao_tieu_hao_nhien_lieu_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

// Export báo cáo tổng hợp hoạt động ra Excel
export const exportActivitySummaryExcel = createAsyncThunk(
  'report/exportActivitySummaryExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = '',
      groupID = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime,
        groupID: groupID
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/active-overview/excel?${queryString}`;
      const fileName = `Bao_cao_tong_hop_hoat_dong_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

// Export báo cáo chi tiết hoạt động ra Excel
export const exportActivityDetailExcel = createAsyncThunk(
  'report/exportActivityDetailExcel',
  (
    {
      licensePlates = [],
      firstTime = '',
      lastTime = '',
      agencyId = '',
      groupID = ''
    },
    { rejectWithValue }
  ) => {
    return new Promise((resolve, reject) => {
      const params = {
        licensePlate: licensePlates,
        firstTime: firstTime,
        lastTime: lastTime,
        groupID: groupID
      };

      const queryString = buildQueryString(params);
      const url = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/business/active-detail/excel?${queryString}`;
      const fileName = `Bao_cao_chi_tiet_hoat_dong_${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          downloadBlob(res.data, fileName);
          resolve({ success: true });
        })
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);


export const reportDNSlice = createSlice({
  name: 'reportDN',
  initialState: {
    isLoading: false,
    isExporting: false,
    activitySummaryData: null,
    activityDetailData: null,
    fuelDrainFillData: null,
    fuelSummaryData: null,
    fuelConsumptionData: null,
    monitoringAreaData: null,

    totalSummary: 0,
    totalDetail: 0,
    totalFuelDrainFill: 0,
    totalFuel: 0,
    totalFuelConsumption: 0,
    totalMonitoringArea: 0
  },
  reducers: {
    resetDataScreen: state => {
      state.activitySummaryData = null;
      state.activityDetailData = null;
      state.fuelDrainFillData = null;
      state.fuelSummaryData = null;
      state.fuelConsumptionData = null;
      state.monitoringAreaData = null;
      state.totalSummary = 0;
      state.totalDetail = 0;
      state.totalFuelDrainFill = 0;
      state.totalFuel = 0;
      state.totalFuelConsumption = 0;
      state.totalMonitoringArea = 0;
    },
  },
  // reportActivityDetail
  extraReducers: {
    [reportActivitySummary.pending]: state => {
      state.isLoading = true;
    },
    [reportActivitySummary.fulfilled]: (state, action) => {
      state.activitySummaryData = action.payload.data;
      state.totalSummary = action.payload.total;
      state.isLoading = false;
    },
    [reportActivitySummary.rejected]: (state, action) => {
      state.activitySummaryData = null;
      state.totalSummary = 0;
      state.isLoading = false;
    },

    [reportActivityDetail.pending]: state => {
      state.isLoading = true;
    },
    [reportActivityDetail.fulfilled]: (state, action) => {
      state.activityDetailData = action.payload.data;
      state.totalDetail = action.payload.total;
      state.isLoading = false;
    },
    [reportActivityDetail.rejected]: (state, action) => {
      state.activityDetailData = null;
      state.totalDetail = 0;
      state.isLoading = false;
    },

    [reportFuelDrainFill.pending]: state => {
      state.isLoading = true;
    },
    [reportFuelDrainFill.fulfilled]: (state, action) => {
      state.fuelDrainFillData = action.payload.data;
      state.totalFuelDrainFill = action.payload.total;
      state.isLoading = false;
    },
    [reportFuelDrainFill.rejected]: (state, action) => {
      state.fuelDrainFillData = null;
      state.totalFuelDrainFill = 0;
      state.isLoading = false;
    },

    [reportFuelSummary.pending]: state => {
      state.isLoading = true;
    },
    [reportFuelSummary.fulfilled]: (state, action) => {
      state.fuelSummaryData = action.payload.data;
      state.totalFuel = action.payload.total;
      state.isLoading = false;
    },
    [reportFuelSummary.rejected]: (state, action) => {
      state.fuelSummaryData = null;
      state.totalFuel = 0;
      state.isLoading = false;
    },
    [reportFuelConsumption.pending]: state => {
      state.isLoading = true;
    },
    [reportFuelConsumption.fulfilled]: (state, action) => {
      state.fuelConsumptionData = action.payload.data;
      state.totalFuelConsumption = action.payload.total;
      state.isLoading = false;
    },
    [reportFuelConsumption.rejected]: (state, action) => {
      state.fuelConsumptionData = null;
      state.totalFuelConsumption = 0;
      state.isLoading = false;
    },
    [reportMonitoringArea.pending]: state => {
      state.isLoading = true;
    },
    [reportMonitoringArea.fulfilled]: (state, action) => {
      state.monitoringAreaData = action.payload.data;
      state.totalMonitoringArea = action.payload.total;
      state.isLoading = false;
    },
    [reportMonitoringArea.rejected]: (state, action) => {
      state.monitoringAreaData = null;
      state.totalMonitoringArea = 0;
      state.isLoading = false;
    },
    [exportFuelSummaryExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportFuelSummaryExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportFuelSummaryExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportFuelConsumptionExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportFuelConsumptionExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportFuelConsumptionExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportActivitySummaryExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportActivitySummaryExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportActivitySummaryExcel.rejected]: state => {
      state.isExporting = false;
    },
    [exportActivityDetailExcel.pending]: state => {
      state.isExporting = true;
    },
    [exportActivityDetailExcel.fulfilled]: state => {
      state.isExporting = false;
    },
    [exportActivityDetailExcel.rejected]: state => {
      state.isExporting = false;
    },
  }
});

export const { resetDataScreen } = reportDNSlice.actions;

export default reportDNSlice.reducer;
